import { eventBus } from 'globalState/global-state.js';

if (window.config.user.availableMpLinks) {
    if (localStorage.getItem('geoWasUpdate', true)) {
        localStorage.setItem('geoWasUpdate', false);
        if (
            window.config.user.availableMpLinks &&
            !localStorage.getItem('showMpLinksModal')
        ) {
            localStorage.setItem('showMpLinksModal', true);
            eventBus.handleDeprecatedOpenModal.broadcast({
                url: '/availableMpLinksPopup/',
                maxWidth: 600,
            });
        }

        if (
            !window.config.user.availableMpLinks &&
            localStorage.getItem('showMpLinksModal')
        ) {
            localStorage.removeItem('showMpLinksModal');
            eventBus.handleDeprecatedOpenModal.broadcast({
                url: '/availableMpLinksPopup/',
                maxWidth: 600,
            });
        }
    } else {
        if (window.config.user.availableMpLinks) {
            localStorage.setItem('geoWasUpdate', false);
            localStorage.setItem('showMpLinksModal', true);
            eventBus.handleDeprecatedOpenModal.broadcast({
                url: '/availableMpLinksPopup/',
                maxWidth: 600,
            });
        }
    }
} else {
    localStorage.setItem('geoWasUpdate', '');
    localStorage.setItem('showMpLinksModal', '');
}
